import { useEffect, useState } from "react";
import i18n from "i18next";
import { cookieManagerInstance } from "../../../cookies";
import {
    CustomCookieIdentifier,
    DEFAULT_CROSS_PORTAL_COOKIE_OPTIONS,
} from "../../../constants/ShortbreadConfig";
import { DEFAULT_LANGUAGE } from "../../../utils/localizationUtils";
import { getEnabledLanguages } from "../../../utils/customBrandingUtils";
import { Language } from "../../../i18n";

const useI18nLanguage = () => {
    const [language, setLanguage] = useState<string>();
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    const enabledLanguages = getEnabledLanguages();

    useEffect(() => {
        const handleLanguageChange = (lng) => {
            setLanguage(lng);
            cookieManagerInstance.setCookieStorage(
                CustomCookieIdentifier.WSW_LANGUAGE.name,
                lng,
                DEFAULT_CROSS_PORTAL_COOKIE_OPTIONS
            );
        };

        i18n.on("languageChanged", handleLanguageChange);

        return () => {
            i18n.off("languageChanged", handleLanguageChange);
        };
    }, []);

    useEffect(() => {
        const selectedLanguageFromCookie = cookieManagerInstance.getCookieStorage(
            CustomCookieIdentifier.WSW_LANGUAGE.name
        );
        const selectedlanguage =
            language ?? selectedLanguageFromCookie ?? i18n.language;
        if (!enabledLanguages || enabledLanguages.size === 0) {
            changeLanguage(selectedlanguage);
            return;
        }

        // Custom localized messages exist
        if (enabledLanguages.has(selectedlanguage as Language)) {
            changeLanguage(selectedlanguage);
            return;
        }
        if (enabledLanguages.has(Language.English)) {
            changeLanguage(Language.English);
            return;
        }
        changeLanguage(Array.from(enabledLanguages).sort()[0]);
    }, Array.from(enabledLanguages ?? []));

    return { language: language ?? DEFAULT_LANGUAGE, changeLanguage };
};

export default useI18nLanguage;
